import * as routes from "@/utils/routes";
import type RouteBase from "@/utils/routes/RouteBase";

const generateNestedRoutes = (): RouteBase[] => {
  const routesWithoutOwnPage = Object.values(routes).filter((item) => !item.hasOwnPage);

  let nestedRoutes = Object.values(routes).filter((item) => !item.parent && item.key !== "home");

  routesWithoutOwnPage.forEach((item) => {
    nestedRoutes = nestedRoutes.filter(
      (nestedRoute) => !Object.values(item.children ?? {}).includes(nestedRoute)
    );
  });

  return nestedRoutes.sort((a, b) => a.priority - b.priority);
};

export default generateNestedRoutes;
